import { Entity } from '@/models/types/Entity';

import { create } from 'jsondiffpatch';
import { JsondiffpatchConverter } from '@/utils/diff/DiffConverter';
import { Difference } from '@/utils/diff/Difference';

export function generateDiff(oldEntity: Entity, newEntity: Entity) {
  const diffpatcher = create({
    objectHash: (obj: any) => obj?.id ?? JSON.stringify(obj),
    arrays: {
      detectMove: true,
    },
  });
  const converter = new JsondiffpatchConverter(oldEntity, newEntity);
  const delta = diffpatcher.diff(oldEntity, newEntity);

  const result = converter.convert(delta);

  return result as Difference[];
}
